import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

const APPS = {
  'portal-stg.tranna.net': {
    applicationId: '79f20cb5-906e-4ee6-9a40-d7664e811d64',
    clientToken: 'pub3a5ba8bb414575bb2cf0ea8042c2bc87',
    service: 'portal-stg',
    env: 'staging',
  },
};

const isInitialized = () => APPS[window.location.hostname] !== undefined;

export const initDatadog = () => {
  const config = APPS[window.location.hostname];
  if (!config) return;

  datadogRum.init({
    ...config,
    site: 'datadoghq.eu',
    version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: false })],
  });
};

export const identifyDatadogUser = () => {
  if (!isInitialized()) return;
  try {
    const raw = sessionStorage.getItem('data');
    if (!raw) return;
    const admin = JSON.parse(raw);
    if (!admin?.id) return;
    datadogRum.setUser({
      id: String(admin.id),
      name: admin.name,
      email: admin.email,
      access_level: admin.access_level,
    });
  } catch {
    // sessionStorage unavailable or malformed JSON — skip silently
  }
};

export const clearDatadogUser = () => {
  if (!isInitialized()) return;
  datadogRum.clearUser();
};
